import React from 'react'
import { Link } from 'react-router-dom'

export default function PartnersSection() {
  const partners = [
    { name: 'Gordon Delivery Denmark ApS', file: 'gordon.png' },
    { name: 'HARTMAN LOGISTIK ApS', file: 'hartman-logistik.png' },
    { name: 'Jetpak Denmark Air & Logistics ApS', file: 'jetpak.png' },
    { name: 'PostNord', file: 'postnord.png' },
    { name: 'BHS Logistics', file: 'bhs-logistics.png' },
    { name: 'CATERING DANMARK ApS', file: 'catering-danmark.png' },
    { name: 'FACT DANMARK A/S', file: 'fact.png' },
    { name: 'XPRESSEN ApS', file: 'xpressen.png' },
    { name: 'Factor', file: 'factor.png' },
    { name: 'Frokostfirmaet', file: 'frokostfirmaet.png' },
    { name: 'FANØ LAKS ApS', file: 'fanoe-laks.png' },
    { name: 'SLAGTER CHRISTIANSEN FANØ ApS', file: 'slagter-christiansen-fanoe.png' },
    { name: 'ULVEDAL OST ApS', file: 'ulvedal.png' },
    { name: '1883 Grand Fromage', file: '1883-grand-fromage.png' },
  ]

  return (
    <section className="bg-slate-100/70 border-y border-slate-200/80 py-16 lg:py-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col space-y-12">

          {/* Text Header & Intro */}
          <div className="space-y-4 text-center max-w-3xl mx-auto">
            <div className="inline-flex items-center gap-2 px-3.5 py-1.5 rounded-full bg-sky-100 text-sky-800 text-xs font-bold uppercase tracking-wider">
              <i className="fa-solid fa-handshake text-sky-600" aria-hidden="true" />
              <span>Dokumenteret samarbejde</span>
            </div>
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold text-slate-900 tracking-tight leading-tight">
              Vores partnere og kunder
            </h2>
            <p className="text-slate-600 text-base sm:text-lg leading-relaxed">
              Gennem mere end 2 år har Transport4U opbygget et tillidsfuldt samarbejde med en lang række anerkendte virksomheder og logistikleverandører i hele landet.
            </p>
          </div>

          {/* Full-width Partner logos grid with much larger cards and logos */}
          <div className="w-full">
            <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 gap-6 sm:gap-8">
              {partners.map((partner, idx) => (
                <div
                  key={idx}
                  className="bg-white rounded-3xl p-6 sm:p-10 border border-slate-200/90 shadow-sm flex items-center justify-center min-h-[170px] sm:min-h-[200px] lg:min-h-[220px] hover:border-sky-400 hover:shadow-md transition-all duration-200"
                  title={partner.name}
                >
                  <img
                    src={`/cdn-cgi/image/width=600,quality=90,format=auto/_assets/${partner.file}`}
                    alt={partner.name}
                    loading="lazy"
                    className="max-h-24 sm:max-h-28 lg:max-h-32 w-auto max-w-[88%] object-contain transition-transform duration-200 hover:scale-105"
                  />
                </div>
              ))}
            </div>
          </div>

          {/* Video centered below or alongside with full width presentation */}
          <div className="w-full max-w-4xl mx-auto flex items-center justify-center">
            <div className="w-full rounded-2xl border border-slate-200/90 shadow-sm relative overflow-hidden bg-slate-900 flex items-center justify-center">
              <video
                src="https://assets.auxodev.dk/assets/070d40dc-3ad7-4f6e-9a43-382bc6e79eb3/video-2026-09-06-15-33-26.mp4"
                controls
                autoPlay
                loop
                muted
                playsInline
                preload="auto"
                className="w-full h-auto max-h-[520px] object-contain block"
                aria-label="Transport4U flåde i drift"
              />
            </div>
          </div>

          {/* CTA Buttons & Contact info */}
          <div className="flex flex-col items-center space-y-4 pt-2">
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4 w-full max-w-md">
              <Link
                to="/kontakt"
                className="w-full sm:w-auto flex-1 inline-flex items-center justify-center px-8 py-4 rounded-xl bg-sky-500 hover:bg-sky-400 text-slate-950 font-black text-sm tracking-wider uppercase transition-colors shadow-sm text-center"
              >
                BESTIL TRANSPORT
              </Link>
              <a
                href="mailto:transport4u.dk@gmail.com"
                className="w-full sm:w-auto flex-1 inline-flex items-center justify-center gap-2 px-8 py-4 rounded-xl bg-slate-900 hover:bg-slate-800 text-white font-black text-sm tracking-wider uppercase transition-colors shadow-sm text-center"
              >
                <i className="fa-solid fa-envelope text-sky-400" aria-hidden="true" />
                <span>SEND E-MAIL</span>
              </a>
            </div>
            <div className="text-sm text-slate-500">
              Telefon: <a href="tel:+4550352035" className="font-semibold text-slate-700 hover:text-sky-600 transition-colors">50 35 20 35</a>
            </div>
          </div>

        </div>
      </div>
    </section>
  )
}
